import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import AdminHeader from "@/components/AdminHeader";
import { toast } from "sonner";
import { Save } from "lucide-react";

const FIELDS = [
  { key: "company_name", label: "Nom de l'entreprise" },
  { key: "manager_name", label: "Gérant" },
  { key: "phone", label: "Téléphone" },
  { key: "email", label: "Email de contact" },
  { key: "address_line1", label: "Adresse (ligne 1)" },
  { key: "address_line2", label: "Adresse (ligne 2)" },
  { key: "postal_code", label: "Code postal" },
  { key: "city", label: "Ville" },
  { key: "country", label: "Pays" },
  { key: "siret", label: "SIRET" },
  { key: "vat_number", label: "Numéro TVA" },
  { key: "logo_url", label: "URL du logo" },
];

export default function AdminSettings() {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/settings").then((r) => setForm(r.data));
  }, []);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/admin/settings", form);
      setForm(data);
      toast.success("Paramètres enregistrés");
    } catch (err) {
      toast.error("Échec de l'enregistrement");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="admin-settings-page">
      <AdminHeader />
      <main className="max-w-3xl mx-auto pt-28 pb-16 px-6 lg:px-10">
        <div className="text-xs tracking-[0.5em] gold uppercase">Paramètres</div>
        <h1 className="mt-2 font-serif text-white text-4xl">Informations entreprise</h1>
        <p className="mt-3 text-gray-400 text-sm">
          Ces informations apparaissent sur le site, les emails, les devis et les factures.
        </p>

        <form onSubmit={save} className="mt-10 space-y-5">
          {FIELDS.map((f) => (
            <label key={f.key} className="block">
              <div className="text-[11px] font-semibold text-gray-400 uppercase tracking-widest mb-2">
                {f.label}
              </div>
              <input
                data-testid={`settings-${f.key}`}
                value={form[f.key] ?? ""}
                onChange={set(f.key)}
                className="w-full bg-black border border-white/10 px-4 py-3 text-white focus:outline-none focus:border-[color:var(--gold)]"
              />
            </label>
          ))}
          <button
            data-testid="settings-save"
            disabled={saving}
            type="submit"
            className="btn-gold inline-flex items-center gap-2"
          >
            <Save size={16} /> {saving ? "Enregistrement..." : "Enregistrer"}
          </button>
        </form>

        {form.logo_url && (
          <div className="mt-10 border border-white/10 bg-[#0d0d0d] p-6">
            <div className="text-xs tracking-widest gold uppercase mb-3">Aperçu du logo</div>
            <img src={form.logo_url} alt="logo" className="h-24 object-contain" />
          </div>
        )}
      </main>
    </div>
  );
}
